import { defineNuxtPlugin } from '#app';
import { usePosthog } from '~/composables/usePosthog';
export default defineNuxtPlugin((nuxtApp) => {
  const user = useSupabaseUser();
  const { posthog } = usePosthog({
    capture_pageview: false,
    capture_pageleave: true,
  });

  // Make sure that pageviews are captured with each route change
  const router = useRouter();
  router.afterEach((to, from) => {
    const params = {
      current_url: to.fullPath,
    };
    // only capture if the route name changed
    if (to.name !== from.name) {
      if (user.value?.email) {
        posthog?.identify(
          user.value?.email, // Required. Replace 'distinct_id' with your user's unique identifier
          { email: user.value?.email }, // $set, optional
          { initial_url: window.location.href } // $set_once properties
        );
      }
      posthog?.capture('$pageview', params);
    }
  });

  /**
   * Error handling
   */
  nuxtApp.hook('vue:error', (error) => {
    posthog?.captureException(error);
  });

  return {
    provide: {
      posthog: () => posthog,
    },
  };
});
